export const en = {
  avgUsageAfterLeak: {
    perWeek: "/ week",
    title: "Avg usage after leak",
    tooltip: "Average weekly usage the past 8 weeks after the code was leaked",
  },
  avgUsageBeforeLeak: {
    perWeek: "/ week",
    title: "Avg usage before leak",
    tooltip: "Average weekly usage the past 8 weeks before the code was leaked",
  },
  codeEndedBeforeLeak: "Inactive after leak",
  codeStartedAfterLeak: "Inactive before leak",
  common: {
    more: "more",
    na: "N/A",
  },
  firstSeen: {
    title: "First seen",
    tooltip: "Date this code was first discovered",
  },
  highRisk: {
    tooltip: "High Risk Code",
  },
  initialScanInProgress: {
    description: "We are currently scanning your store for leaked codes. This can take up to 10-20 minutes.",
    title: "Initial scan in progress",
  },
  leakedCode: {
    description: "Get alerted when your coupon leaks on a coupon website. Coupon values are updated every scan.",
    plural: "Coupons",
    singular: "Coupon",
  },
  leakedOnAppInstallation: "Coupon leak was scanned on app installation. The data is not available.",
  leakStatus: {
    leaked: "Leaked",
    notLeaked: "Not leaked",
    title: "Leak status",
    tooltip: "If the code is currently being leaked",
  },
  noLeaksFound: {
    description: "We will alert you when we find leaked codes.",
    title: "No leaks found",
  },
  noResult: {
    description: "We will alert you when we find leaked codes.",
    title: "No leaks found",
  },
  search: {
    placeholder: "Search in leaks",
  },
  shopifyStatus: {
    active: "Active",
    doesNotExist: "Does not exist",
    doesNotExistTooltip: "This code does not exist in your Shopify discounts",
    expired: "Expired",
    title: "Shopify Status",
    tooltip: "If the code is currently active in your Shopify store",
  },
  sources: {
    title: "Sources",
    tooltip: "Websites where this code was found",
  },
  value: {
    title: "Value",
  },
} as const;
